<template>
  <v-card elevation="4">
    <v-card-title>
      <div class="d-flex align-center" style="width: 100%">
        <div class="flex-grow-1 text-h5 font-weight-medium d-flex align-center">
          Solicitação de Consentimento
          <HelpDialog
            class="mx-4"
            title="Solicitação de Consentimentos"
            message="Preciso de ajuda para solicitar consentimentos."
          >
            Esta página serve para solicitar titulares dos dados consentimentos para a realização de determinado tratamento de dados.
            <v-expansion-panels class="my-2" ripple>
              <v-expansion-panel>
                <v-expansion-panel-header color="grey lighten-2">
                  Precisa de ajuda para criar a solicitação de consentimento?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  Siga o <b>passo a passo</b> abaixo para cadastrar uma solicitação:
                  <ul>
                    <li class="mt-2">
                      <b>1:</b> Selecione o modelo que deseja utilizar ou então inicie sem modelo
                    </li>
                    <li class="mt-2">
                      <b>2:</b> Caso já tenha relação com o titular, selecione-o na lista. Senão, Clique em novo titular e insira os dados de um novo titular
                    </li>
                    <li class="mt-2">
                      <b>3:</b> Escolha os dados que serão utilizados para o tratamento de dados.
                    </li>
                    <li class="mt-2">
                      <b>4:</b> Descreva uma ou mais finalidades desse tratamento de dadoo.
                    </li>
                    <li class="mt-2">
                      <b>5:</b> Selecione a forma com a qual o tratamento de dados será feita.
                    </li>
                    <li class="mt-2">
                      <b>6:</b> Selecione a duração que terá para uso e armazenamento dos dados.
                    </li>
                    <li class="mt-2">
                      <b>7:</b> Selecione quais os controladores que terão acesso aos dados.
                    </li>
                    <li class="mt-2">
                      <b>8:</b> Selecione todas as responsabilidades dos controladores durante o acesso dos dados.
                    </li>
                    <li class="mt-2">
                      <b>9:</b> Selecione as consequências caso o titular não aceite o consentimento.
                    </li>
                    <li class="mt-2">
                      <b>10:</b> Selecione com quais os riscos o titular deve concordar para realizar o tratamento de dados.
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header color="grey lighten-2">
                  Porque tantas informações?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  A LGPD descreve que o titular deve ter acesso fácil às seguintes informações: (Artigo 9)
                  <ul>
                    <li class="mt-2">
                      <b>I:</b> finalidade específica do tratamento;
                    </li>
                    <li class="mt-2">
                      <b>II:</b> forma e duração do tratamento, observados os segredos comercial e industrial;
                    </li>
                    <li class="mt-2">
                      <b>III:</b> identificação do controlador;
                    </li>
                    <li class="mt-2">
                      <b>IV:</b> informações de contato do controlador;
                    </li>
                    <li class="mt-2">
                      <b>V:</b> informações acerca do uso compartilhado de dados pelo controlador e a finalidade;
                    </li>
                    <li class="mt-2">
                      <b>VI:</b> responsabilidades dos agentes que realizarão o tratamento;
                    </li>
                    <li class="mt-2">
                      <b>VII:</b> direitos do titular, com menção explícita aos direitos contidos no art. 18 desta Lei.
                    </li>
                    <li>...</li>
                    <li class="mt-2">
                      <b>§ 3º</b> Quando o tratamento de dados pessoais for condição para o fornecimento de produto ou de serviço ou para o exercício de direito, o titular será informado com destaque sobre esse fato e sobre os meios pelos quais poderá exercer os direitos do titular elencados no art. 18 desta Lei.
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header color="grey lighten-2">
                  Não consegue usar uma opção diferente em algum campo?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  O cadastro dos campos Dados de Titular, Controladores, Responsabilidades, Formas, Duração, Riscos e Consequências
                  são feitos separadamente no menu lateral, abaixo do submenu "Cadastros".
                  <br />
                  <b>Acesse por lá</b> para gerenciar as opções disponíveis. 
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header color="grey lighten-2">
                  Quem é o titular em caso de menores de idade?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  <p>
                    Em caso de menores de idade, pelo menos um dos pais ou responsável legal deve consentir pelo tratamento de dados.
                  </p>
                  <p>
                    Baseado na LGPD, Art. 14 (§1º e §5º).
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header color="grey lighten-2">
                  Qual deve ser a finalidade do consentimento?
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-4">
                  <p>
                    Para melhor proteção judicial, as Finalidades devem se referir a fins <b>específicos</b>, principalmente em casos de tratamento de dados sensíveis.
                  </p>
                  <p>
                    Baseado na LGPD, Art. 7 (§2º) e Art. 11 (inciso I).
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </HelpDialog>
        </div>
        <div class="text-body-2">
          <v-progress-circular indeterminate v-if="loadingBalance"/>
          <div v-else-if="consentsBalance === null" class="error--text font-weight-medium">
            Erro ao carregar número de <br/>consentimentos disponíveis
          </div>
          <template v-else-if="consentsBalance <= 0">
            <v-chip label color="error">
              <v-icon left>mdi-alert-octagon-outline</v-icon>
              Sem consentimentos disponíveis
            </v-chip>
          </template>
          <template v-else>
            {{ consentsBalance || "-" }} Consentimentos Disponíveis
          </template>
        </div>
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-fade-transition group class="fill-height" tag='div'>

        <div key="inCharge-form" v-if="currentStatus == 'inCharge-form'">
          <v-alert type="warning" icon="mdi-alert-outline" mandatory>
            <b> Atenção! </b>
            Indique o Encarregado pela LGPD da sua Empresa
          </v-alert>
          <div class="mx-1 text-body-2 grey--text text--darken-4 text-justify font-weight-medium">
            <p>
              É obrigatório que a empresa tenha um encarregado pela LGPD, que
              responde sobre cumprimento da lei. Cadastre o encarregado atual da
              empresa para criar requisições de consentimento.
            </p>
            <span class="text-subtitle-2">
              Trechos retirados da lei:
            </span>
            <v-card color="grey lighten-3 pa-4 mt-2">
              <p class="mb-0">
                É a pessoa indicada pelo controlador e operador para atuar como canal de comunicação entre o controlador, os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD)
              </p>
              <div class="text-h5">
                ...
              </div>
              <p class="mt-3">
                § 1º A identidade e as informações de contato do encarregado deverão ser divulgadas publicamente, de forma clara e objetiva, preferencialmente no sítio eletrônico do controlador.
              </p>
              <p class="mb-0">
                § 2º As atividades do encarregado consistem em:
                <ul>
                  <li> I - aceitar reclamações e comunicações dos titulares, prestar esclarecimentos e adotar providências; </li>
                  <li> II - receber comunicações da autoridade nacional e adotar providências; </li>
                  <li> III - orientar os funcionários e os contratados da entidade a respeito das práticas a serem tomadas em relação à proteção de dados pessoais; e </li>
                  <li> IV - executar as demais atribuições determinadas pelo controlador ou estabelecidas em normas complementares. </li>
                </ul>
              </p>
            </v-card>
            <p class="mt-4">
              O encarregado pode ser qualquer pessoa envolvida com a empresa, até mesmo o proprietário.
            </p>
          </div>
          <v-card-text>
            <InCharge
              :allowCancel="false"
              mountEditingInfo
              saveMessage="Salvar Encarregado e Continuar"
              @created="currentStatus = 'selecting-templates'"
            />
          </v-card-text>
        </div>


        <div key="filling-form" v-if="currentStatus == 'filling-form'">
          <v-form ref="consentForm" @submit.prevent="createConsentRequest()">
            <v-card-text>
              <ConsentForm v-model="consent" showBearerField :disabled="loadingSave" />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                class="mr-2"
                color="success"
                type="submit"
                :loading="loadingSave"
              >
                Solicitar Consentimento
              </v-btn>
            </v-card-actions>
          </v-form>
        </div>

        <div
          key="loading-selected-template" v-if="currentStatus == 'loading-selected-template'"
          class="d-flex flex-column align-center justify-center"
          style="
            position: absolute;
            left: 50%; margin-left: -117.5px;
            top: 50%; margin-top: -50px;
          "
        >
          <v-progress-circular
            color="primary"
            indeterminate
            size="50"
          />
          <span class="mt-6 text-subtitle-2">
            Carregando Modelo Selecionado
          </span>
        </div>


        <v-card key="selecting-templates" v-if="currentStatus == 'selecting-templates'" elevation="5" color="grey lighten-3" class="mx-4 mt-5 fill-height">
          <v-card-title>
            <div
              style="width: 100%"
              class="d-flex align-center justify-space-between"
            >
              <div>Modelos</div>
              <div>
                <v-btn
                  color="info"
                  elevation="3"
                  @click="currentStatus = '', changeStatus('filling-form')"
                >
                  Iniciar sem Modelo
                </v-btn>
              </div>
            </div>
            <v-divider />
            <v-text-field
              v-model="searchQuery"
              prepend-icon="mdi-magnify"
              label="Buscar"
              hide-details
              clearable
            />
          </v-card-title>

          <v-skeleton-loader
            type="list-item@4"
            v-if="loadingTemplates"
          />
          <template v-else-if="templates.length == 0">
            <v-card-text class="d-flex align-center flex-column">
              <span class="text-subtitle-2 warning--text">
                Ainda não há nenhum modelo cadastrado.
              </span>
              <v-btn color="secondary" small outlined class="mt-3" :to="{name: 'templates'}">
                Criar Agora
              </v-btn>
            </v-card-text>
          </template>
          <v-list v-else color="white" class="py-0">
            <v-list-item v-if="filteredSearch.length == 0">
              <v-list-item-title class="text-subtitle-2">
                Nenhum Modelo encontrado com o título "{{ searchQuery }}"
              </v-list-item-title>
            </v-list-item>
            <template v-else v-for="template in filteredSearch">
              <div :key="template.id">
                <v-divider />
                <v-list-item @click="loadTemplate(template)">
                  <v-list-item-content>
                    <v-list-item-title class="text-subtitle-2 black--text">
                      {{ template.template_name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn color="primary" x-small fab depressed @click="loadTemplate(template)">
                      <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </template>
          </v-list>
        </v-card>
      </v-fade-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import InCharge from "@/components/SettingsTabs/AccountDataForms/InCharge.vue"
import ConsentForm from "@/components/ConsentForm.vue";
import HelpDialog from "@/components/HelpDialog.vue"

export default {
  name: "NewConsent",
  components: {
    InCharge, ConsentForm, HelpDialog,
  },

  data: () => ({
    loadingBalance: false,
    consentsBalance: undefined,
    loadingTemplates: false,
    loadingSave: false,
    searchQuery: "",
    currentStatus: "selecting-templates", //loading-selected-template 
    hints: false,
    inCharge: undefined,
    consent: {
      bearer_id: undefined,
      new_bearer: undefined,
      purposes: [""],
      means_id: undefined,
      duration_id: [],
      controllers: [],
      bearerInfos: [],
      consequences: [],
      risks: [],
      responsibilities: [],
    },
    templates: [],
  }),

  mounted(){
    this.checkInCharge();
    this.getTemplates();
    this.loadConsentsBalance();
  },

  computed: {
    filteredSearch() {
      if (!this.searchQuery){
        return this.templates
      }
      return this.templates.filter((item) => {
        return item.template_name.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
  },

  methods: {
    loadConsentsBalance(){
      this.loadingBalance = true;
      this.$axios.get('/consents-balance')
        .then((response) => {
          this.consentsBalance = response.data;
        })
        .catch(() => {
          this.consentsBalance = null;
        })
        .finally(() => {
          this.loadingBalance = false;
          this.initialLoading = false;
        })
    },
    checkInCharge(){
      this.$axios.get('/incharge')
        .then((response) => {
          let inCharge = response.data
          if (!!inCharge.id){
            this.inCharge = inCharge
          } else {
            this.inCharge = {}
            this.currentStatus = ''
            this.changeStatus('inCharge-form')
          }
        })
        .catch(() => {
          this.$showMessage("error", "Erro ao carregar encarregado da empresa");
        })
    },
    createConsentRequest() {
      if (!this.$refs.consentForm.validate()) {
        this.$showMessage("warning", "Preencha todos os campos corretamente");
      } else {
        this.loadingSave = true;
        this.$axios
          .post("/consent", this.consent)
          .then((response) => {
            this.$showMessage("success", "Solicitação de Consentimento Criada com Sucesso");
            this.$router.push({
              name: "consent",
              params: {
                consent_id: response.data
              },
            });
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 400) {
                this.$refs.ConsentForm.openNewContactDialog();
                return;
              }
              if (error.response.status == 402) {
                this.$showMessage("warning", "Não há mais Consentimentos Disponíveis");
                return;
              }
              if (error.response.status == 404) {
                this.$showMessage("warning", "O encarregado pela LGPD da Empresa deve ser definido");
                return;
              }
            }
            this.$showMessage("error", "Falha inesperada na criação de requisição de consentimento");
          })
          .finally(() => {
            this.loadingSave = false;
          });
      }
    },
    getTemplates() {
      this.loadingTemplates = true;
      this.$axios
        .get("/consent_request_template")
        .then((response) => {
          this.templates = response.data;
        })
        .catch((error) => {
          this.$showMessage("error", "Erro Inesperado no Carregamento dos Modelos");
        })
        .finally(() => {
          this.loadingTemplates = false;
        });
    },
    changeStatus(newStatus, callback){
      this.$nextTick(() => {
        setTimeout(() => {
          this.currentStatus = newStatus
          if (callback) callback()
        }, 500);
      })
    },
    loadTemplate(template){
      this.loadingSelectedTemplate = true;
      this.currentStatus = 'loading-selected-template'
      this.$nextTick(() => {
        this.$axios
          .get(`/consent_request_template/${template.id}`)
          .then((response) => {
            this.consent = response.data;
            this.changeStatus('filling-form')
          })
          .catch((error) => {
            this.$showMessage("error", "Erro Inesperado ao Carregar Modelo");
            this.changeStatus('selecting-templates')
          })
      })
    },
  },

};
</script>
